import * as angular from "angular";

angular.module("ecanvasserServices", [
    "vcServices",
    "userService",
    "nationbuilderService",
    "campaignService",
    "canvassService",
    "contactService",
    "queryService",
    "remindersService",
    "surveyService",
    "boundsService",
    "filterService",
    "exportService",
    "filterService",
    "leadsService",
    "organisation",
    "textAngular",
]);
